module.exports = __webpack_public_path__ + "img/power_treads_int.4e4dc568.png";